import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Button, Icon, Loader, Modal, Popup, Segment, Table } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import CreditCardStore from "~/stores/Credit/CreditCardStore";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import ModalError from "~/components/element/ModalError";
import ToastMessageStore from "~/stores/ToastMessageStore";
import CustomerStore from "~/stores/CustomerStore";
import ProviderStore from "~/stores/Provider/ProviderStore";

@observer
class CreditCardTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmationModalVisible: false,
      deleteCreditCardIndex: null,
    };
  }

  showConfirmationModal = deleteCreditCardIndex =>
    this.setState({ deleteCreditCardIndex, confirmationModalVisible: true });

  hideConfirmationModal = () => this.setState({ deleteCreditCardIndex: null, confirmationModalVisible: false });

  deleteCreditCard(creditCardId) {
    const { creditCardStore, showError, t, toastMessageStore } = this.props;

    return creditCardStore.delete(creditCardId).then(() => {
      creditCardStore.loadIndex().catch(error => showError(error.message));
      toastMessageStore.addToastMessage(t("billingCentral:creditCardHasBeenDeleted"), "positive", t("success"));
    });
  }

  render() {
    const { actualUserStore, creditCardStore, t } = this.props;
    const { confirmationModalVisible, deleteCreditCardIndex } = this.state;

    const { isLoading: actualUserLoading, actualUser } = actualUserStore;
    const { creditCards, isLoading: creditCardLoading, hasCreditCards } = creditCardStore;

    if (actualUserLoading || creditCardLoading) {
      return (
        <div className="side-page-loader">
          <Loader active inline="centered" />
        </div>
      );
    }

    const addCreditCardButton = (
      <div className="clear-floated">
        <Button
          style={{ textAlign: "center", marginTop: "1rem" }}
          color="green"
          icon="add"
          content={t("add")}
          floated="right"
          as={Link}
          to="/billing-central/credit-cards/add"
        />
      </div>
    );

    if (!hasCreditCards) {
      return (
        <>
          {addCreditCardButton}
          <Segment textAlign="center">{t("billingCentral:noCreditCards")}</Segment>
        </>
      );
    }

    return (
      <>
        {addCreditCardButton}
        <Table textAlign="center" columns={3}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t("billingCentral:cardName")}</Table.HeaderCell>
              <Table.HeaderCell>{t("billingCentral:cardNumber")}</Table.HeaderCell>
              <Table.HeaderCell>&nbsp;</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {creditCards.map((creditCard, index) => (
              <Table.Row key={creditCard.creditCardId}>
                <Table.Cell>{creditCard.cardName}</Table.Cell>
                <Table.Cell>{creditCard.maskedCardNumber}</Table.Cell>
                <Table.Cell verticalAlign="middle">
                  {actualUser.defaultCreditCardId !== creditCard.creditCardId ? (
                    <Button icon color="red" onClick={() => this.showConfirmationModal(index)}>
                      <Icon name="trash alternate" /> {t("delete")}
                    </Button>
                  ) : (
                    <Popup
                      content={t("clientPanelMisc:cantDeleteDefaultCreditCard")}
                      on={["hover", "click"]}
                      trigger={
                        <Button icon color="red" style={{ opacity: ".45" }}>
                          <Icon name="trash alternate" /> {t("delete")}
                        </Button>
                      }
                    />
                  )}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>

        <Modal open={confirmationModalVisible} onClose={() => this.hideConfirmationModal()}>
          {deleteCreditCardIndex !== null && (
            <>
              <Modal.Header>
                {t("billingCentral:areYouSureYouWantToDeleteCreditCard", {
                  creditCardMaskedNumber: creditCards[deleteCreditCardIndex].maskedCardNumber,
                })}
              </Modal.Header>
              <Modal.Actions>
                <Button secondary onClick={() => this.hideConfirmationModal()}>
                  Cancel
                </Button>
                <Button
                  primary
                  onClick={() => {
                    this.deleteCreditCard(creditCards[deleteCreditCardIndex].creditCardId);
                    this.hideConfirmationModal();
                  }}
                >
                  Ok
                </Button>
              </Modal.Actions>
            </>
          )}
        </Modal>
        <ModalError nestStore={creditCardStore} />
      </>
    );
  }
}

CreditCardTable.propTypes = {
  actualUserStore: PropTypes.oneOfType([PropTypes.instanceOf(ProviderStore), PropTypes.instanceOf(CustomerStore)]),
  creditCardStore: PropTypes.instanceOf(CreditCardStore),
  t: PropTypes.func.isRequired,
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};
export default withTranslation()(ErrorWrapper(CreditCardTable));
